<template>
  <div>
  
    <CCard style="margin-top: 20px">
        <CCol xs="12" lg="12" style="margin-top: 20px">
        
            <CTabs variant="pills">
              <CTab title="Betting Table" active>
                <hr>
                <BettingTable></BettingTable>
              </CTab>
              <CTab title="Betting Answer">
                <hr>
              <Bettinganswer></Bettinganswer>
              </CTab> 
              <CTab title="Betting Amount">
                <hr>
              <BettingAmount></BettingAmount>
              </CTab> 
   <CTab title="Betting settlement">
            <Betting_history></Betting_history>
          </CTab>
            </CTabs>
        
      </CCol>
    
    </CCard>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import Bettinganswer from "./bettinganswer.vue"
import BettingTable from "./bettingTable.vue"
import BettingAmount from "./bettingAmount.vue"
import Betting_history from "./betting_history.vue";
export default {
  components: {
    BettingTable,
    Bettinganswer,
    BettingAmount,
 Betting_history,
  },
  data() {
    return {
      activeTab: 1,
      value1: [],
   
     
    };
  },
  watch: {
   
  },
  methods: {
    
    // sendmsg(){}
  },
  created() {

  },
};
</script>
<style >
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
  background-color: #4638c2;
  height: 100%;
  width: 15%;
  -webkit-animation: sk-wave 1.2s ease-in-out infinite;
  animation: sk-wave 1.2s ease-in-out infinite;
}
</style>